export default __webpack_public_path__ + "static/mia-91e874baa11d3b4a95a326886a634f8a.jpg";